import type { ResponseGetMerchflowCdtRelease } from "@CommonApi/merchflows/_merchflowId_/cdt/release";
import type { LengthUnit } from "@CommonUtils/cdtStudio/domain/studioTypes";

/**
 * The unit the category's raw lengths are hundredths of, for the words only: no measure reads
 * it. The one place it is read from the backend: the CDT release response's `lengthUnit` (the
 * base planogram's PSA project's). Absent, or with no release, inches.
 */
export const categoryLengthUnitOf = (
  release?: Pick<ResponseGetMerchflowCdtRelease, "lengthUnit"> | null,
): LengthUnit => release?.lengthUnit ?? "in";
